import { useInView } from "../../hooks/useInView";

/**
 * AnimatedSection — wraps content with a fade-up entrance animation
 * triggered when the section enters the viewport.
 */
export default function AnimatedSection({
  children,
  className = "",
  delay = 0,
  direction = "up", // "up" | "left" | "right" | "fade"
  as: Tag = "div",
}) {
  const [ref, isVisible] = useInView();

  const getTransform = () => {
    if (!isVisible) {
      switch (direction) {
        case "left": return "translateX(-40px)";
        case "right": return "translateX(40px)";
        case "fade": return "none";
        default: return "translateY(40px)";
      }
    }
    return "none";
  };

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: getTransform(),
        transition: `opacity 0.8s ease ${delay}ms, transform 0.8s ease ${delay}ms`,
      }}
    >
      {children}
    </Tag>
  );
}
